export default __webpack_public_path__ + "static/media/ic-log-out.790c8842.svg";